import { Platform } from 'react-native';
import JailMonkey from 'jail-monkey';

// jail-monkey has no web implementation; native-only check.
export const isDeviceCompromised = () => {
    if (Platform.OS === 'web') return false;
    if (__DEV__) return false;
    try {
        return JailMonkey.isJailBroken() || JailMonkey.hookDetected();
    } catch (error) {
        console.log('Jailbreak/root detection failed:', error);
        return false;
    }
};

// Debugger/instrumentation-framework (e.g. Frida, Objection) attach onto the running
// process trips isDebuggedMode — checked separately since it's async and can change
// mid-session (a static, launch-only check can't catch tools attached after startup).
export const isBeingInstrumented = async () => {
    if (Platform.OS === 'web') return false;
    if (__DEV__) return false;
    try {
        return await JailMonkey.isDebuggedMode();
    } catch (error) {
        console.log('Instrumentation detection failed:', error);
        return false;
    }
};
